import React from 'react'
import styled from 'styled-components'
import { Image, Input, Button, Popconfirm, Upload } from 'antd'
import {
    UploadOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    DeleteOutlined,
    PlusOutlined
} from '@ant-design/icons'

const Container = styled.div`
    .banner-wrapper {
        margin-bottom: 10px;
        padding: 10px;
        background-color: #eeeeee;
        .banner-image-wrapper {
            display: flex;
            > .image {
                flex: 1;
            }
            > .action {
                display: flex;
                padding-left: 10px;
                flex-direction: column;
                button {
                    margin-bottom: 10px;
                }
            }
        }
    }
    .left-description {
        margin-left: 10px;
        color: #b2b2b2;
    }
`

const BannerList = ({
    T,
    banners = [],
    max = 1,
    onMove,
    onRemove,
    onAdd,
    onChange,
    onChangeValue
}) => {
    let lastIndex = banners.length - 1
    return (
        <Container>
            {banners.map((banner, index) => (
                <div className="banner-wrapper" key={banner.id || index}>
                    <div className="banner-image-wrapper">
                        <div className="image">
                            <Image src={banner.image} />
                        </div>
                        <div className="action">
                            <Upload
                                accept="image/gif, image/jpeg, image/png, image/webp"
                                fileList={[]}
                                customRequest={() => {}}
                                onChange={e => onChange(index, e)}>
                                <Button
                                    type="primary"
                                    shape="circle"
                                    icon={<UploadOutlined />}
                                />
                            </Upload>

                            <Popconfirm
                                title={T('CONFIRM_REMOVE_MSG')}
                                onConfirm={() => onRemove(index)}
                                okText={T('YES')}
                                cancelText={T('NO')}>
                                <Button
                                    type="primary"
                                    shape="circle"
                                    danger
                                    icon={<DeleteOutlined />}
                                />
                            </Popconfirm>
                            <Button
                                shape="circle"
                                icon={<ArrowUpOutlined />}
                                disabled={index == 0}
                                onClick={() => onMove(index, 'UP')}
                            />
                            <Button
                                shape="circle"
                                icon={<ArrowDownOutlined />}
                                disabled={index == lastIndex}
                                onClick={() => onMove(index, 'DOWN')}
                            />
                        </div>
                    </div>
                    <div>
                        <Input
                            addonBefore={T('TITLE')}
                            placeholder={`e.g. Banner ${index + 1}`}
                            style={{ marginBottom: 10 }}
                            value={banner.title}
                            onChange={e =>
                                onChangeValue(index, 'title', e.target.value)
                            }
                        />
                        <Input
                            addonBefore="URL"
                            placeholder="e.g. https://www.example.com"
                            value={banner.url}
                            onChange={e =>
                                onChangeValue(index, 'url', e.target.value)
                            }
                        />
                    </div>
                </div>
            ))}
            <Upload
                accept="image/gif, image/jpeg, image/png, image/webp"
                multiple
                fileList={[]}
                customRequest={() => {}}
                onChange={onAdd.bind(this)}>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    disabled={max != -1 && banners.length >= max}>
                    {T('ADD_IMAGE')}{' '}
                </Button>

                {max != -1 && (
                    <span className="left-description">
                        ({T('STOCK_LEFT', { count: max - banners.length })})
                    </span>
                )}
            </Upload>
        </Container>
    )
}

export default BannerList
